import { useQuery } from '@tanstack/react-query';
import type { AccountShellExperience } from '@finance/contracts';
import { apiFetch } from '../../api/http-client';

export const ACCOUNT_SHELL_QUERY_KEY = ['auth', 'account-shell'] as const;

async function fetchAccountShell(): Promise<AccountShellExperience> {
  return apiFetch<AccountShellExperience>('/api/auth/me/account-shell');
}

export function useAccountShell() {
  return useQuery({
    queryKey: ACCOUNT_SHELL_QUERY_KEY,
    queryFn: fetchAccountShell,
    staleTime: 30_000,
  });
}
